const getRateTypeSuffix = (rateType: string) => {
  if (rateType === 'PER_HOUR') {
    return `/hr (fixed)`;
  }
  if (rateType === 'TIER_RATE') {
    return `/hr`;
  }
  if (rateType === 'FLAT_FEE') {
    return '';
  }
};

export const formatRate = (price: number | string, rateType: string, label: string, addPrefix = true) => {
  const numericPrice = typeof price === 'string' ? Number(price) : price;
  const disallowed = rateType === 'DISALLOWED';
  const prefix = disallowed ? '✗' : '✓';
  const rateSuffix = getRateTypeSuffix(rateType);
  if (rateSuffix === undefined) {
    return `${addPrefix ? `${prefix} ` : ''}${label}: N/A`;
  }
  const formattedPrice = disallowed
    ? 'N/A'
    : !numericPrice
      ? 'Free'
      : numericPrice >= 100
        ? `$${numericPrice}`
        : `$${numericPrice.toFixed(2)}`;
  const suffix = disallowed || !numericPrice ? '' : rateSuffix;
  return `${addPrefix ? `${prefix} ` : ''}${label}: ${formattedPrice}${suffix}`;
};
